
import { ChangeEvent,useEffect, useState } from 'react';
import { Avatar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Icon} from '@mui/material';
import { IVFormErrors, VForm, VTextField, VTextFieldNumberReal, useVForm } from '../../../shared/forms';
import * as yup from 'yup';
import { useNavigate} from 'react-router-dom';
import { FabricasService } from '../../../shared/services/api/cadastros/FabricasService';
import { Environment } from '../../../shared/environment';

interface IFormData {
    nome: string;
    grupo: number;
    arquivo: string;
    logo?: string;
    multiplo: number;
}
export interface ConfirmationDialogRawProps {
  id: string;
  value: string;
  open: boolean;
  onClose: (value?: string) => void;
}
const formValidationSchema: yup.ObjectSchema<IFormData> = yup.object().shape({
  nome: yup.string().required('O nome é obrigatório'),
  grupo: yup.number().required('O grupo é obrigatório'),
  arquivo: yup.string().optional().default(''),
  logo: yup.string().optional(), 
  multiplo: yup.number().required('O múltiplo é obrigatório'),
});

export const DialogoFabricas: React.FC<ConfirmationDialogRawProps> = (props: ConfirmationDialogRawProps) => {

  const { onClose, value: valueProp, open, ...other } = props;
  const [value, setValue] = useState(valueProp);
  const {formRef, save, } = useVForm();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [image, setImage] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | undefined>();

  const handleSave = (dados: IFormData) => {
    formValidationSchema
      .validate(dados, { abortEarly: false })
      .then((dadosValidados) => {
        setIsLoading(true);
        if (props.id === 'novo') {
          FabricasService.create(dadosValidados).then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              alert(result.message);
            } else {
              onClose(valueProp);
            }
          });
        } else {
          const updateImage = selectedImage && URL.createObjectURL(selectedImage) !== image;
          const updateData = () => {
            FabricasService.updateById(props.id, dadosValidados)
              .then((dataResult) => {
                if (dataResult instanceof Error) {
                  alert(`Erro ao atualizar dados: ${dataResult.message}`);
                } else {
                  onClose(valueProp);
                }
              })
              .catch((error) => {
                console.error('Erro ao atualizar dados:', error);
              })
              .finally(() => {
                setIsLoading(false);
              });
          };
          if (updateImage) {
            FabricasService.updateByIdImg(props.id, selectedImage)
              .then((imgResult) => {
                if (imgResult instanceof Error) {
                  alert(`Erro ao atualizar imagem: ${imgResult.message}`);
                }
              })
              .finally(() => {
                updateData();
              });
          } else {
            updateData();
          }
        }
      })
      .catch((errors: yup.ValidationError) => {
        const validationErrors: IVFormErrors = {};
  
        errors.inner.forEach((error) => {
          if (!error.path) return;
          validationErrors[error.path] = error.message;
        });
  
        formRef.current?.setErrors(validationErrors);
      });
  };
  useEffect(() => {
    if (open) {
      if (props.id !== 'novo') {
        setIsLoading(true);
        FabricasService.getById(props.id).then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            alert(result.message);
          } else {
            formRef.current?.setData(result);
            if (result.logo) {
              setImage(Environment.URL_IMGFABRICA + result.logo);
            } else {
              setImage(null);
            }
          }
        });
      } else {
        formRef.current?.setData({
          nome: '',
          grupo: '',
          arquivo: '',
          logo: null,
          multiplo: 0,
        });
        setImage(null);
      }
    } else {
      formRef.current?.setData({
        nome: '',
        grupo: '',
        arquivo: '',
        logo: null,
        multiplo: 0,
      });
      setImage(null);
      setSelectedImage(undefined);
    }
  }, [open]);
  
  const handleImageChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedImage(event.target.files?.[0]);
    const imagen =  event.target.files?.[0];  
    if (imagen) {
      const imageUrl = URL.createObjectURL(imagen);
      setImage(imageUrl);  
    }
  };
  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);
  const handleCancel = () => {
    onClose();
  };
  return (
    <Dialog
    open={open}
    fullWidth // Garante que o diálogo ocupe toda a largura permitida
    maxWidth="md" // Define a largura máxima como extra large (ou pode usar 'lg', 'md', etc.)
    sx={{ '& .MuiDialog-paper': { maxHeight: '80vh' } }} // Define altura máxima para 90% da viewport
    {...other}
    >
      <DialogTitle>Fabricas</DialogTitle>
      <DialogContent dividers>
  <VForm ref={formRef} onSubmit={handleSave} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
    <Grid container direction="row" spacing={1}>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
        <Box width="100%">
          <input
            type="file"
            id="avatar-input"
            accept="image/*"
            style={{ display: 'none' }}
            onChange={handleImageChange}
          />
          <label htmlFor="avatar-input">
          <Avatar 
  variant="rounded"
  alt="F"
  src={image || '/img-placeholder.png'} // coloque uma imagem padrão local ou no public
  sx={{ width: '100%', height: 200 }}
  onError={(e) => {
    (e.target as HTMLImageElement).src = '/img-placeholder.png'; // fallback local
  }}
/>
          </label>
        </Box>
      </Grid>
      <Grid item xs={12} sm={8} md={8} lg={8} xl={8}>
        <Grid container direction="column" spacing={2}>
          <Grid container item direction="row" spacing={1}>
            <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
              <VTextField
                fullWidth
                size='small'
                name="nome"
                disabled={isLoading}
                label="Nome"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
              <VTextField
                fullWidth
                size='small'
                name="grupo"
                disabled={isLoading}
                label="Grupo"
              />
            </Grid>
          </Grid>
          <Grid container item direction="row" spacing={1}>
            <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
              <VTextField
                fullWidth
                size='small'
                name="arquivo"
                disabled={isLoading}
                label="Arquivo"
              />
            </Grid>
            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
              <VTextFieldNumberReal
                fullWidth
                size='small'
                name="multiplo"
                disabled={isLoading}
                label="Multiplo"
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </VForm>
</DialogContent>
<DialogActions>
  <Button sx={{ minWidth: '25%' }} variant="outlined" color="error" onClick={handleCancel}>
    Cancelar
  </Button>
  <Button sx={{ minWidth: '25%' }} variant="outlined" autoFocus onClick={save}>
    Confirmar
  </Button>
</DialogActions>
    </Dialog>
    
  );
}; 